import { render, staticRenderFns } from "./NamingWebsiteDeep.vue?vue&type=template&id=f8fc7e94&"
import script from "./NamingWebsiteDeep.vue?vue&type=script&lang=js&"
export * from "./NamingWebsiteDeep.vue?vue&type=script&lang=js&"
import style0 from "./NamingWebsiteDeep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports